'use client';

import { collectionLoader } from '@/utils/fetchCollection';
import React, { useEffect, useState } from 'react';
import { FaChevronDown, FaChevronUp } from 'react-icons/fa';
import { useLanguage } from '@/app/LanguageContext';
import { useTranslate } from '@/utils/languageTranslation';
interface FAQItem {
  question: string;
  answer: string | React.ReactNode;
}


export const FAQ = () => {
  const {t} = useTranslate()
  const { language } = useLanguage();
  const [faq, setFaq] = useState<FAQItem[]>([
    {
      question:'',
      answer:''
    }
  ]);

  useEffect(() => {
       const fetchData = async () => {
            const response = await collectionLoader<FAQItem>('faqs', language);
            console.log('Fetched data:', response);
            setFaq(response);
       }
       fetchData();
  },[]);
  const [expandedIndex, setExpandedIndex] = useState<number | null>(null);

  const toggleAccordion = (index: number) => {
    setExpandedIndex((prevIndex) => (prevIndex === index ? null : index));
  };

  return (
    <div className="bg-white xl:w-[71rem] w-full md:max-w-[71rem] mx-auto my-20 px-5 xl:px-0">
      <h2 className="text-xl font-semibold text-gray-800 mb-6 ">{t('have_any_questions')}</h2>
      <div className="space-y-2 border-0">
        {faq.map((item, index) => (
          <div key={index} className="border border-slate-300  overflow-hidden">
            <button
              className="flex items-center justify-between text-sm md:text-base w-full py-3 px-4 text-left text-gray-700 font-semibold focus:outline-none hover:bg-slate-100"
              onClick={() => toggleAccordion(index)}
            >
              <span>{item.question}</span>
              {expandedIndex === index ? (
                <FaChevronUp className="text-gray-500" />
              ) : (
                <FaChevronDown className="text-gray-500" />
              )}
            </button>
            {expandedIndex === index && (
              <div className="py-3 px-4 bg-gray-50 text-gray-600 text-sm">
                {item.answer}
              </div>
            )}
          </div>
        ))}
      </div>
    </div>
  );
};

// Example Usage:
// const ExampleFAQ: React.FC = () => {
//   const faqItems: FAQItem[] = [
//     {
//       question: 'What is the role of the Ethiopian Technology Authority ( ETA ) ?',
//       answer:
//         'The Ethiopian Technology Authority ( ETA ) oversees national technology policies , sets standards , and ensures digital security while promoting innovation and technological advancement across the country .',
//     },
//     {
//       question: 'Does ETA support tech startups and innovation projects ?',
//       answer: 'Yes, ETA has various initiatives and programs aimed at supporting tech startups and fostering innovation within the Ethiopian technology ecosystem.',
//     },
//     {
//       question: 'Does ETA provide training or awareness programs ?',
//       answer:
//         'ETA conducts training sessions, workshops, and awareness campaigns to enhance digital literacy, cybersecurity practices, and understanding of national technology policies.',
//     },
    // Add more FAQ items here
  // ];

//   return (
//     <div className="container mx-auto p-6">
//       <FAQ title="Have any questions ?" items={faqItems} />
//     </div>
//   );
// };

// export default ExampleFAQ;